
import ReportDownloadOptions from "./report-download-options.vue";
export default {
  components: {
    ReportDownloadOptions
  },
  data() {
    return {
      menu: false
    };
  }
};
